<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="累计返现" :width="1200" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        "><a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="代理商">
                                <a-input v-model:value="queryParam.nickname" placeholder="代理商姓名或手机号"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                                <a-button type="primary" style="margin-left: 8px"
                                    @click="handleTixianRecord">提现记录</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'nickname'">
                        <a>{{ record.nickname }}</a>
                    </template>
                    <template v-if="column.dataIndex === 'operate'">
                        <a @click="handleDetail(record)">明细</a>
                        <a-divider type="vertical" />
                        <a-popover trigger="click" overlayClassName="customer-options-popover">
                            <template #content>
                                <a-popconfirm title="确定全部转入余额?" placement="left" @openChange="(e) => { }"
                                    @confirm="sendBalance(record)">
                                    <p>转入余额</p>
                                </a-popconfirm>
                                <p @click="openDirectChange(record)">直接提现</p>
                                <a-popconfirm title="确定发微信红包?" placement="left" @openChange="
                                    (e) => {
                                        openWeixinChange(e, record)
                                    }
                                " @confirm="sendWeixin(record)">
                                    <template #description>
                                        <a-form style="width: 500px; margin-top: 30px" v-bind="formLayout">
                                            <a-form-item label="红包金额" style="width: 800px" required>
                                                <a-input v-model:value="record.tixian_amount" placeholder="请输入金额"
                                                    style="width: 320px" addonBefore="￥" addonAfter="元"> </a-input>
                                            </a-form-item>
                                        </a-form>
                                    </template>
                                    <p>微信红包</p>
                                </a-popconfirm>
                            </template>
                            <a>提现</a>
                        </a-popover>
                    </template>
                </template>
            </a-table>
        </a-card>
        <!-- 明细 -->
        <FreeMoneyRecord v-if="state.detailVisible" :detailData="state.detailData" @cancel="handleCancel()">
        </FreeMoneyRecord>
        <!-- 提现记录 -->
        <FreeMoneyTixian v-if="state.tixianVisible" @cancel="tixianCancel()"></FreeMoneyTixian>
        <!-- 直接提现 -->
        <a-modal v-model:open="directData.visible" :title="directData.nickname + '-直接提现'" @cancel="directCancel"
            width="800px">
            <template #footer>
                <a-button key="back" @click="directCancel">取消</a-button>
                <a-button key="submit" type="primary" :loading="directData.loading" @click="sendDirect">提交</a-button>
            </template>
            <a-form :model="directData" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                <a-form-item label="提现金额" style="width: 800px" required>
                    <a-input v-model:value="directData.tixian_amount" placeholder="请输入金额" style="width: 320px"
                        addonBefore="￥" addonAfter="元"> </a-input>
                </a-form-item>
                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="发票" required>
                    <Upload :upload_path="`public/uploads/manage/财务管理/排队免单/${dayjs().format('YYYYMM')}/`"
                        uploadType="text" :accept="['pdf', 'jpeg', 'jpg', 'png']" :limitation="99"
                        v-model:value="directData.tixian_invoice" uploadText="上传附件">
                    </Upload>
                </a-form-item>
                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="备注" required>
                    <a-textarea v-model:value="directData.tixian_remark" placeholder="备注" allow-clear :rows="6" />
                </a-form-item>
            </a-form>
        </a-modal>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
import Upload from '@/components/base/Upload.vue'
import FreeMoneyRecord from './components/FreeMoneyRecord.vue'
import FreeMoneyTixian from './components/FreeMoneyTixian.vue'
const props = defineProps({})
const emit = defineEmits(['cancel'])
const columns = [
    {
        title: '代理商',
        dataIndex: 'nickname',
        width: 200
    },
    {
        title: '返现余额',
        dataIndex: 'money',
        width: 300
    },
    {
        title: '累计金额',
        dataIndex: 'money_all',
        width: 300
    },
    {
        title: '添加时间',
        dataIndex: 'created_at',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 200
    }
]
const formLayout = {
    labelCol: {
        xs: { span: 4 },
        sm: { span: 4 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
interface state {
    loading: boolean
    detailData: object
    detailVisible: boolean
    tixianVisible: boolean
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    detailVisible: false,
    tixianVisible: false
})
let queryParam = reactive<any>({
    full_name: ''
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/freemoneyList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
//显示明细
const handleDetail = (record) => {
    state.detailVisible = true
    state.detailData = record
}
const handleCancel = () => {
    state.detailVisible = false
}
//全部转入余额
const sendBalance = (record) => {
    let requestParam = {
        url: '/admin/v1/freemoney/sendBalance',
        method: 'post',
        data: {
            id: record.id
        }
    }
    baseService(requestParam).then((res: any) => {
        message.success(res.msg)
        loadData()
    })
}
//发微信红包
const openWeixinChange = (e, record) => {
    record.tixian_amount = record.money
    if (!e) {
        record.tixian_amount = null
    }
}
const sendWeixin = (record) => {
    if (record.tixian_amount <= 0 || record.tixian_amount > 200) {
        message.warn('请输入大于0且小于200的金额')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    let requestParam = {
        url: '/admin/v1/freemoney/sendWeixinMoney',
        method: 'post',
        data: {
            id: record.id,
            tixian_amount: record.tixian_amount
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
    return null
}
//直接提现
const directData = reactive({
    visible: false,
    loading: false,
    pid: 0,
    nickname: '',
    tixian_amount: 0,
    tixian_invoice: [],
    tixian_remark: ''
})
const openDirectChange = (record) => {
    directData.visible = true
    directData.loading = false
    //初始化表单
    directData.pid = record.id
    directData.nickname = record.nickname
    directData.tixian_amount = record.money
    directData.tixian_invoice = []
    directData.tixian_remark = ''
}
const directCancel = () => {
    directData.visible = false
}
const sendDirect = () => {
    if (directData.tixian_amount <= 0) {
        message.warn('请输入大于0的金额')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (directData.tixian_invoice.length <= 0) {
        message.warn('请上传发票')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (!directData.tixian_remark) {
        message.warn('请输入提现账号信息')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    let requestParam = {
        url: '/admin/v1/freemoney/sendDirectMoney',
        method: 'post',
        data: directData
    }
    directData.loading = true
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            directData.visible = false
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            directData.loading = false
        })
    return null
}
//显示提现记录
const handleTixianRecord = () => {
    state.tixianVisible = true
}
const tixianCancel = () => {
    state.tixianVisible = false
}
</script>
<style lang="less" scoped>
.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}
</style>
